/* eslint-disable camelcase */
export default {
  // 'this' - $store
  byActionType: {
    
  },
  // 'this' - $store
  byEventType: {
    'KICK_OFF' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'info',
        value: {
          number: 0,
          yards: 0
        }
      })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      this.setIngameProperty({
        property: 'leftSideTeam',
        value: TeamNumber
      })
    },
    'START_PERIOD' ({ GamePeriod, extra: { team1, team2 } }) {
      if (GamePeriod === 1) return

      const { leftSideTeam } = this.getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })
    },
    'START_OVERTIME_PERIOD' ({ extra: { team1, team2 } }) {
      const { leftSideTeam } = this.getIngameData

      this.setIngameProperty({
        property: 'leftSideTeam',
        value: leftSideTeam === 1 ? 2 : 1
      })
    },
    'POSESSION_1' (event) {
      const { TeamNumber, extra } = event

      this.setActiveSide(TeamNumber)

      if (!extra) {
        return
      }

      this.setIngameProperty({
        property: 'coords',
        value: {
          x: extra.yards || '',
          y: extra.ball_y_in_percents || ''
        }
      })
    },
    'POSESSION_2' (event) {
      const { TeamNumber, extra } = event

      this.setActiveSide(TeamNumber)

      if (!extra) {
        return
      }

      this.setIngameProperty({
        property: 'coords',
        value: {
          x: extra.yards || '',
          y: extra.ball_y_in_percents || ''
        }
      })
    },
    'ATTACK' (event) {
      const { TeamNumber, extra } = event

      this.setActiveSide(TeamNumber)

      if (!extra) {
        return
      }

      this.setIngameProperty({
        property: 'coords',
        value: {
          x: extra.yards || '',
          y: extra.ball_y_in_percents || ''
        }
      })
    },
    'DEFENSE' (event) {
      const { TeamNumber, extra } = event

      this.setActiveSide(TeamNumber)

      if (!extra) {
        return
      }

      this.setIngameProperty({
        property: 'coords',
        value: {
          x: extra.yards || '',
          y: extra.ball_y_in_percents || ''
        }
      })
    },
    'DOWN' (event) {
      const { extra } = event

      if (!extra) {
        return
      }

      this.setIngameProperty({
        property: 'info',
        value: {
          number: extra.down_number || 0,
          yards: extra.yards || 0
        }
      })
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    'POSESSION_2' (event) {
      const { awayTeamTitle } = this

      if (!event.eventInfo || !event.extra) return ''

      return `${event.eventInfo.title} ${awayTeamTitle} / ${event.extra.yards} ${this.$tc('nfl.yards', event.extra.yards)}`
    },
    'POSESSION_1' (event) {
      const { homeTeamTitle } = this

      if (!event.eventInfo || !event.extra) return ''

      return `${event.eventInfo.title} ${homeTeamTitle} / ${event.extra.yards} ${this.$tc('nfl.yards', event.extra.yards)}`
    },
    'ATTACK' (event) {
      const { eventInfo, extra, TeamNumber } = event

      if (!event.eventInfo || !extra) return eventInfo.title

      const { homeTeamTitle, awayTeamTitle } = this

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${event.eventInfo.title} ${teamTitle} / ${event.extra.yards} ${this.$tc('nfl.yards', event.extra.yards)}`
    },
    'DEFENSE' (event) {
      const { eventInfo, extra, TeamNumber } = event

      if (!event.eventInfo || !extra) return eventInfo.title

      const { homeTeamTitle, awayTeamTitle } = this

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${event.eventInfo.title} ${teamTitle} / ${event.extra.yards} ${this.$tc('nfl.yards', event.extra.yards)}`
    },
    'DOWN' (event) {
      const { eventInfo, extra, TeamNumber } = event

      if (!event.eventInfo || !extra) return eventInfo.title

      const { homeTeamTitle, awayTeamTitle } = this

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${teamTitle} / ${event.extra.down_number} ${this.$t('nfl.down')} - ${event.extra.yards} ${this.$tc('nfl.yards', event.extra.yards)}`
    },
    'STARTING_SIDE' (event) {
      const { TeamNumber } = event

      const { homeTeamTitle, awayTeamTitle } = this

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      return `${this.$t('nfl.starting.team')} / ${teamTitle}`
    },
    'FINISH_PERIOD' (event) {
      const { GamePeriod } = event

      if (GamePeriod === 5) {
        return this.$t('nfl.finish.overtime.single')
      }
      
      if (GamePeriod > 5) {
        return this.$t('nfl.finish.overtime', { period: GamePeriod - 4 })
      }

      return this.$t('nfl.finish', { period: GamePeriod })
    },
    'START_PERIOD' (event) {
      const { GamePeriod } = event

      if (GamePeriod === 5) {
        return this.$t('nfl.overtime.single')
      }
      
      if (GamePeriod > 5) {
        return this.$t('nfl.overtime', { period: GamePeriod - 4 })
      }

      return this.$t('nfl.start', { period: GamePeriod })
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.bullets')

    if (type === 'overtime') return this.$t('trader.win.overtime')

    return this.$t('trader.win.maintime')
  }
}
